import React, { useEffect, useState } from "react"
import { useContrato } from "../../../../../../../context/ContratoContext";
// import { Total } from "../../../../../../../services/data/dummyContratos";
// import { useModal } from "../../../../../../../hooks/ModalContext";
import { Proposta } from "../propostas";
import { useDividas } from "../../../../../../../context/DividasContext";
import { BiMinusCircle, BiPlusCircle } from 'react-icons/bi'
import { usePropostas } from "../../../../../../../context/PropostasContext";
import { Badge, Checkbox } from "flowbite-react";
import { useFila } from "../../../../../../../context/FilaContext";
import { useCadastro } from "../../../../../../../context/CadastroContext";

interface ContratoDataProps {
  vencimento?: string;
  formaPag?: string;
}

interface ContratoState {
  cpf_cnpj: string, codcredor: string, contrato: string
}

export const ContratoData = ({ vencimento, formaPag }: ContratoDataProps) => {
  const {

    showParcelasContrato,
    contratosData,
  } = useContrato()
  const { propostasData, getSelectedContrato, selectedContrato, getPropostas, getSelectedProposta, date, selectedProposta } = usePropostas()
  const { selectedCredor, devedor } = useDividas()
  const { ultimoCPF } = useCadastro()
  const [show, setShow] = useState(false)
  const [contrato, setContrato] = useState<ContratoState>({} as ContratoState)

  async function getProps(data?: string) {
    let d = data ? data : ''
    if (propostasData?.length > 0 && !date && devedor?.cpf_cnpj !== ultimoCPF) {
      await getPropostas({ codcredor: contrato.codcredor, cpf_cnpj: contrato.cpf_cnpj, contrato: contrato.contrato, url: selectedCredor.url_ws, vencimento: d, formapagamento: formaPag })
      getSelectedProposta()
    }
    if (propostasData?.length > 0 && date && !selectedProposta) {
      await getPropostas({ codcredor: contrato.codcredor, cpf_cnpj: contrato.cpf_cnpj, contrato: contrato.contrato, url: selectedCredor.url_ws, vencimento: d, formapagamento: formaPag })
      getSelectedProposta()
    }
    if (propostasData?.length > 0 && date && selectedProposta && devedor?.cpf_cnpj === ultimoCPF) {
      await getPropostas({ codcredor: contrato.codcredor, cpf_cnpj: contrato.cpf_cnpj, contrato: contrato.contrato, url: selectedCredor.url_ws, vencimento: d, formapagamento: formaPag })
    }
  }

  useEffect(() => {
    getProps(date)
  }, [date])

  useEffect(() => {
    getProps()
  }, [formaPag])


  async function checkedContrato(cpf_cnpj: string, codcredor: string, numcontrato: string) {
    if (numcontrato !== contrato.contrato) {
      setContrato({ codcredor, cpf_cnpj, contrato: numcontrato })
    }

    if (propostasData.length <= 0 || numcontrato !== contrato.contrato) {
      await getPropostas({ codcredor, cpf_cnpj, contrato: numcontrato, url: selectedCredor.url_ws, vencimento, formapagamento: formaPag })
    }
    setShow(!show)
  }

  function formatDate(date: string) {
    const [dia, mes, ano] = date?.split('/')
    return `${mes}/${dia}/${ano}`
  }

  return (<>
    {
      contratosData?.contratos?.length > 0 && contratosData.contratos.filter(item => item.permiteproposta).map(c => (
        <div key={c.numcontrato} className={`mb-4 rounded-md bg-white `} >
          <div className="flex w-full rounded-md border border-gray-400 pr-2">
            <div
              className={`mr-2 w-2 rounded-l-md ${c.permiteproposta ? " bg-green-500" : " bg-red-500"
                } `}
            ></div>
            <div className="w-full py-2">
              <div>
                <div className="my-2 flex items-center justify-between text-sm">
                  <div className="flex items-center ">
                    {
                      !c.permiteproposta && (
                        <Checkbox
                          color="green"
                          className="mr-2 bg-primary"
                          onChange={() => {
                            selectedContrato ? getSelectedContrato() : getSelectedContrato(c.numcontrato)
                          }}
                        />
                      )
                    }

                    <strong className="font-medium text-sm text-gray-600">
                      Contrato: {c.numcontrato}

                    </strong>
                  </div>
                  {
                    !c.permiteproposta && (
                      <>
                        <Badge color="success">
                          Acordado
                        </Badge>
                      </>
                    )
                  }


                  {/* <p className="font-medium text-xs text-gray-600">
                    Dias em atraso:
                    <strong className="ml-1">
                      {differenceInDays(new Date(formatDate(c.prestacoes[0].validade)), new Date(),)}
                    </strong>
                  </p> */}

                  {
                    c.permiteproposta && (
                      <button
                        className="text-lg font-bold"
                        onClick={() => {
                          checkedContrato(devedor.cpf_cnpj || '', c.codcredor, c.numcontrato)
                          showParcelasContrato(c.numcontrato);
                        }}
                      >

                        {
                          show && c.numcontrato === contrato.contrato ? <BiMinusCircle size={24} className="fill-primary" /> : <BiPlusCircle size={24} className="fill-primary" />
                        }

                      </button>
                    )
                  }

                </div>
              </div>
              {/* && c.numcontrato !== contrato.contrato */}
              <div
                className={`${(!show || c.numcontrato !== contrato.contrato) && "hidden"
                  } `}
              >
                <>
                  {/* <TabelaParcelasData /> */}
                  {
                    propostasData && propostasData.length > 0 && propostasData.map(proposta => (
                      <Proposta proposta={proposta} contrato={c.numcontrato} />
                    ))

                  }
                </>

              </div>
            </div>
          </div>
        </div>
      )

      )
    }
  </>)
}